/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum SessionState {
  /**
   * The state where Yospace returns the stream playback URL to be played by
   * the application’s video player and which is monitored by Yospace Session.
   */
  PLAYER_READY_WITH_SESSION_MONITOR,

  /**
   * The state where Yospace fails to return the stream playback URL and
   * the Yospace initialisation URL to the Central Streaming Manager is
   * used instead.
   */
  PLAYER_READY_NO_SESSION,

  /**
   * The state where Yospace Session is fully initialized including
   * analytic tracking.
   */
  SESSION_ACTIVE_WITH_ANALYTICS,

  /**
   * The state where Yospace Session failed to initialize analytics tracking
   * component but playback may be possible.
   */
  SESSION_ACTIVE_NO_ANALYTICS,

  /**
   * The state where Yospace Session failed to initialize.
   */
  SESSION_INACTIVE,
}
